// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import InstructorService from 'services/InstructorService';
import CourseService from 'services/CourseService';
import LanguageService from 'services/LanguageService';
import LocationService from 'services/LocationService';

// Components
import Loader from 'components/common/Loader';
import Map from 'components/map/Map';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';

//-------------------------------------------------------------------------------------------------------------------

class MapPage extends React.Component {

    constructor(props) {
        super(props);

        this.mapRef = React.createRef();

        this.state = {
            isLoading: true,
            isLoadingFilters: true,
            filters: {
            }
        };
    }
    
    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadFilters();
    }

    async loadFilters() {
        const coursesReq = CourseService.list();
        const languagesReq = LanguageService.list();
        const geosReq = LocationService.listGeos();

        this.setState({
            courses: await coursesReq,
            languages: await languagesReq,
            geos: await geosReq,
            isLoadingFilters: false
        }, () => {
            this.load();
        });
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters
        }, () =>
            this.debounceLoad()
        );
    }

    debounceLoad() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 100);
    }

    async load() {
        GlobalStateService.setValues({
            area: 'map'
        });

        // Get all instructors
        const instructors = await InstructorService.list({
            type: 'Approved',
            ignoreDeactivated: true,
            ...this.state.filters
        });

        // Group instructors by city
        const cities = InstructorService.groupByCity(instructors);

        // Update UI
        this.setState({
            cities,
            isLoading: false
        });
    }

    render() {
        return (
            <div className="page map-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Map</h1>
                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderInner() {
        const {
            isLoading,
            cities
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <Map
                ref={this.mapRef}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBRkRLRyaGMKrRkSTyVOdpfxVrtSsdUeNQ&libraries=&v=weekly"
                loadingElement={<div style={{ height: '100%' }} />}
                containerElement={<React.Fragment />}
                mapElement={<div style={{ height: `calc(100vh - 200px)`, minHeight: 500 }} />}
                cities={cities}
            />

        </>);
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            filters,
            geos,
            courses,
            languages
        } = this.state;
        
        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Geo</Form.Label>
                <select
                    className="form-control"
                    value={filters.geoID || ''}
                    onChange={e => this.updateFilter('geoID', e.target.value)}
                >
                    <option value="">(All geos)</option>
                    {geos.map(g =>
                        <option key={g.id} value={g.id}>{g.name}</option>
                    )}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Course</Form.Label>
                <select
                    className="form-control"
                    value={filters.courseID || ''}
                    onChange={e => this.updateFilter('courseID', e.target.value)}
                >
                    <option value="">(All courses)</option>
                    {courses.map(c =>
                        <option key={c.id} value={c.id}>{c.name}</option>
                    )}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Language</Form.Label>
                <select
                    className="form-control"
                    value={filters.languageID || ''}
                    onChange={e => this.updateFilter('languageID', e.target.value)}
                >
                    <option value="">(All languages)</option>
                    {languages.map(l =>
                        <option key={l.id} value={l.id}>{l.name}</option>
                    )}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Modality</Form.Label>
                <select
                    className="form-control"
                    value={filters.modality || ''}
                    onChange={e => this.updateFilter('modality', e.target.value)}
                >
                    <option value="">ILT & vILT</option>
                    <option value="ILT">ILT</option>
                    <option value="vILT">vILT</option>
                </select>
            </Form.Group>

        </>);
    }
}

export default withRouter(MapPage);